import { useState, useEffect } from 'react';
import { Sparkles } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
} from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';

const WELCOME_POPUP_SHOWN_KEY = 'welcome_popup_shown';

export function WelcomePopup() {
  const [isOpen, setIsOpen] = useState(false);

  useEffect(() => {
    const hasShown = localStorage.getItem(WELCOME_POPUP_SHOWN_KEY) === 'true';
    const justLoggedIn = sessionStorage.getItem('just_logged_in') === 'true';

    if (!hasShown && justLoggedIn) {
      const timer = setTimeout(() => {
        setIsOpen(true);
        localStorage.setItem(WELCOME_POPUP_SHOWN_KEY, 'true');
        // Remove just_logged_in so ReferralPopup can show after this closes
        // ReferralPopup will handle its own logic
      }, 500);
      return () => clearTimeout(timer);
    } else if (hasShown && justLoggedIn) {
      // User already saw welcome, remove flag so popups don't keep showing
      sessionStorage.removeItem('just_logged_in');
    }
  }, []);

  const handleClose = () => {
    setIsOpen(false);
  };

  return (
    <Dialog open={isOpen} onOpenChange={setIsOpen}>
      <DialogContent className="sm:max-w-md">
        <DialogHeader>
          <div className="flex items-center gap-3 mb-2">
            <div className="w-12 h-12 rounded-full bg-gradient-to-br from-primary/20 to-primary/10 flex items-center justify-center">
              <Sparkles className="w-6 h-6 text-primary" />
            </div>
            <div>
              <DialogTitle className="text-xl">E aí, bem-vindo ao Publee!</DialogTitle>
              <DialogDescription className="text-sm">
                Bora criar suas primeiras publis
              </DialogDescription>
            </div>
          </div>
        </DialogHeader>

        <div className="space-y-4 py-4">
          <div className="bg-gradient-to-br from-primary/10 to-primary/5 rounded-lg p-6 border border-primary/20 text-center">
            <div className="inline-flex items-center justify-center w-16 h-16 rounded-full bg-primary/20 mb-4">
              <span className="text-3xl font-bold text-primary">1</span>
            </div>
            <h3 className="text-lg font-semibold mb-2">Crédito de Teste Grátis!</h3>
            <p className="text-sm text-muted-foreground mb-3">
              Você ganhou <strong className="text-primary">1 crédito gratuito</strong> pra testar a plataforma. É nossa cortesia.
            </p>
            <div className="bg-background/50 rounded-lg p-3 text-xs text-muted-foreground">
              Usa esse crédito pra criar sua primeira publi e ver como é fácil!
            </div>
          </div>

          <div className="space-y-2 text-sm">
            <p className="font-medium">🎯 Próximos passos:</p>
            <ul className="space-y-1 text-muted-foreground ml-4">
              <li>• Cria seu primeiro projeto</li>
              <li>• Faz upload de um produto</li>
              <li>• Gera sua primeira publi em minutos</li>
            </ul>
          </div>
        </div>

        <div className="flex gap-2">
          <Button variant="default" className="flex-1 gap-2" onClick={handleClose}>
            <Sparkles className="w-4 h-4" />
            Bora Criar
          </Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
